import * as z from "zod/v4";

const timePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

const customRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

export const selfServeOnboardingStatsSchema = z.object({
  totalCount: z.number().int().min(0),
  completedCount: z.number().int().min(0),
  helpRequestedCount: z.number().int().min(0),
  totalRevenue: z.number().min(0),
  weightedRevenueOnboarded: z.number().min(0),
  averageCompletionTimeMinutes: z.number().min(0),
  averageCompletionPercentage: z.number().min(0).max(100),
  // Previous period comparisons (null for custom time ranges)
  totalCountChange: z.number().nullable().optional(),
  completedCountChange: z.number().nullable().optional(),
  helpRequestedCountChange: z.number().nullable().optional(),
  totalRevenueChange: z.number().nullable().optional(),
  weightedRevenueOnboardedChange: z.number().nullable().optional(),
  averageCompletionTimeMinutesChange: z.number().nullable().optional(),
  averageCompletionPercentageChange: z.number().nullable().optional(),
});

export const getSelfServeOnboardingStats = {
  name: "getSelfServeOnboardingStats" as const,
  input: z
    .object({
      timePeriod: timePeriodSchema,
      customRange: customRangeSchema.optional(),
      excludeCustom: z.boolean().optional(),
    })
    .superRefine((value, ctx) => {
      if (value.timePeriod === "custom" && !value.customRange) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "customRange is required when timePeriod is custom",
          path: ["customRange"],
        });
      }
    }),
  output: selfServeOnboardingStatsSchema,
};

export type SelfServeOnboardingStats = z.infer<
  typeof selfServeOnboardingStatsSchema
>;
export type GetSelfServeOnboardingStatsInput = z.infer<
  typeof getSelfServeOnboardingStats.input
>;
export type GetSelfServeOnboardingStatsOutput = z.infer<
  typeof getSelfServeOnboardingStats.output
>;
